const cards = [
  {
    title: '《星际穿越2》人类最后的远征',
    desc: '诺兰导演最新科幻巨制，人类面临前所未有的生存危机，一场跨越维度的太空冒险即将展开',
    type: '电影',
    rating: '9.2',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20style%20with%20astronaut%20in%20deep%20space%2C%20cosmic%20nebula%20background%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20space%20blue%20contrast%2C%20epic%20cinematic%20composition%2C%20minimalist%20design&width=400&height=560&seq=card-interstellar-2&orientation=portrait',
    alt: '星际穿越2电影海报',
  },
  {
    title: '《长安十二时辰》全集',
    desc: '豆瓣8.8分高分古装悬疑大剧，雷佳音易烊千玺领衔主演，盛世长安暗藏惊天危机',
    type: '电视剧',
    rating: '8.8',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%20with%20Tang%20dynasty%20architecture%20and%20lanterns%2C%20warm%20red%20and%20gold%20palette%2C%20historical%20costume%20drama%20aesthetic%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20candlelight%20glow&width=400&height=560&seq=card-changan-12&orientation=portrait',
    alt: '长安十二时辰电视剧海报',
  },
  {
    title: '《了不起的挑战》第五季',
    desc: '国民级户外真人秀回归，全新嘉宾阵容引爆笑点，每期都是快乐源泉',
    type: '综艺',
    rating: '9.0',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20poster%20style%20with%20colorful%20outdoor%20adventure%20theme%2C%20bright%20and%20energetic%20colors%2C%20fun%20game%20elements%2C%20warm%20vibrant%20palette%20with%20coral%20and%20gold%20accents%2C%20entertaining%20composition&width=400&height=560&seq=card-challenge-show&orientation=portrait',
    alt: '了不起的挑战综艺海报',
  },
  {
    title: '《鬼灭之刃》全系列收录',
    desc: '现象级日漫神作，从第一季到最新剧场版完整收录，燃爆战斗场面不容错过',
    type: '动漫',
    rating: '9.5',
    img: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20with%20dynamic%20sword%20fighting%20scene%2C%20traditional%20Japanese%20art%20style%2C%20dramatic%20fire%20and%20water%20effects%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20energetic%20composition&width=400&height=560&seq=card-demon-slayer&orientation=portrait',
    alt: '鬼灭之刃动漫海报',
  },
  {
    title: '《地球脉动III》4K典藏',
    desc: 'BBC史诗级自然纪录片，4K超清画质呈现地球最震撼的生命奇迹',
    type: '纪录片',
    rating: '9.8',
    img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20style%20with%20stunning%20wildlife%20closeup%2C%20majestic%20landscapes%2C%20rich%20natural%20greens%20and%20golden%20sunlight%2C%20cinematic%20wildlife%20photography%2C%20awe%20inspiring%20composition&width=400&height=560&seq=card-planet-earth-3&orientation=portrait',
    alt: '地球脉动III纪录片海报',
  },
  {
    title: '《泪之女王》全集高甜',
    desc: '2024年度现象级韩剧，金秀贤金智媛主演，财阀夫妻的爆笑又催泪爱情故事',
    type: '韩剧',
    rating: '8.9',
    img: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20drama%20poster%20style%20with%20elegant%20couple%20in%20luxurious%20setting%2C%20soft%20romantic%20lighting%2C%20warm%20rose%20and%20cream%20color%20palette%2C%20emotional%20and%20stylish%20composition&width=400&height=560&seq=card-queen-of-tears&orientation=portrait',
    alt: '泪之女王韩剧海报',
  },
  {
    title: '《白夜追凶2》重磅回归',
    desc: '时隔七年神作续集，潘粤明一人分饰两角再升级，国产悬疑剧天花板回归',
    type: '电视剧',
    rating: '9.1',
    img: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20style%20with%20dual%20identity%20theme%2C%20dark%20urban%20night%20setting%2C%20mysterious%20atmosphere%2C%20split%20face%20concept%2C%20cool%20and%20warm%20tone%20contrast%2C%20suspenseful%20cinematic%20feel&width=400&height=560&seq=card-day-and-night-2&orientation=portrait',
    alt: '白夜追凶2电视剧海报',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-accent-500 uppercase tracking-wide mb-2">推荐内容</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑精选高分好片，挑一部今晚就看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5 max-w-[1200px] mx-auto">
          {cards.slice(0, 7).map((card, idx) => (
            <div
              key={idx}
              className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className={`relative w-full ${idx === 0 ? 'aspect-[16/9]' : 'aspect-[2/3]'}`}>
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium whitespace-nowrap">
                    {card.type}
                  </span>
                  <span className="px-2 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-1">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}